import Proximiio from "proximiio-js-library";
import useMapStore from "@/store/mapStore";
import { useCallback } from "react";

export const useFetchActiveAds = () => {
  const ads = useMapStore((state) => state.ads);
  const setAds = useMapStore((state) => state.setAds);

  const fetchActiveAds = useCallback(async () => {
    try {
      console.log("Fetching ads...");
      const res = await Proximiio.Ads.getAds();
      const currentDate = new Date().getTime();
      const activeAds = res.data.filter((item) => {
        return (
          item.isActive &&
          item.startDate &&
          item.endDate &&
          item.startDate <= currentDate &&
          currentDate <= item.endDate
        );
      });
      setAds(activeAds);
    } catch (error) {
      console.error("Failed to fetch ads:", error);
    }
  }, [setAds]);

  return { ads, fetchActiveAds };
};
